import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-add-recycled-content',
  templateUrl: './add-recycled-content.component.html',
  styleUrls: ['./add-recycled-content.component.scss'],
})
export class AddRecycledContentComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  adminRecycledData: any;
  recycledForm!: FormGroup;
  recycledAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationList: any;
  recycleList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  setIndicatorData: any;
  regionItems: any;
  selectedMaterial: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveRecycledContentEvent = new EventEmitter<any>();

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private administratorService: AdministratorService
  ) {
    this.adminRecycledData = this.modal?.modalService?.config?.initialState?.['recycledData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel == 'Review recycled content detail' ? true : false;
    this.recycleList = this.adminRecycledData.materialItems;
    const placeHolderOrganization = {
      name: 'All organizations',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.adminRecycledData.organizationList
    );
    this.organizationList = newOrganizationlist;
    this.regionItems = this.adminRecycledData.recycledContentList;
    this.organizatioListFunction();
    this.setMaterialList();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.regionItems.length; i++) {
      form[this.regionItems[i].regionName] = new FormControl(
        this.adminRecycledData.recycledContentList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.recycledForm = new FormGroup(form);
    this.recycledAddEditForm = this.formBuilder.group({
      material: [this.adminRecycledData.materialId || null, Validators.required],
      organizationName: [null],
    });
    this.setFormData();
  }

  async organizatioListFunction() {
    await this.organizationList?.map((item: any) => {
      if (item.id == this.adminRecycledData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  async setMaterialList() {
    await this.recycleList.map((item: any) => {
      item.childItems.map((x: any, i: any) => {
        if (item.childItems[i]?.id == this.adminRecycledData.materialId) {
          return (this.selectedMaterial = item.childItems[i]);
        }
      });
    });
  }

  setFormData() {
    this.recycledAddEditForm.patchValue({
      material: this.selectedMaterial,
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      this.recycledAddEditForm.controls['material'].value == 'Material' ||
      !this.recycledAddEditForm.controls['material'].value
    ) {
      return;
    }
    if (this.recycledAddEditForm.status == 'VALID' && this.recycledForm.status == 'VALID') {
      const entires = Object.entries(this.recycledForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.adminRecycledData.recycledContentList.map(
        (obj: any, index: any) => ({
          ...obj,
          ...entires[index],
        })
      );
      entiresArray.forEach((event: any, index: any) => {
        i = {
          materialId: this.adminRecycledData.materialId,
          regionName: event.regionName,
          regionId: event.regionId,
          defaultValue: event[1],
        };
        resultArray.push(i);
      });
      const recyclePayload = {
        materialId:
          this.recycledAddEditForm.controls['material']?.value?.id ||
          this.recycledAddEditForm.controls['material'].value,
        organizationId:
          this.recycledAddEditForm.controls['organizationName'].value?.name == 'All organizations'
            ? null
            : this.recycledAddEditForm.controls['organizationName'].value?.id,
        recycledContentList: resultArray,
      };
      this.saveRecycledContentEvent.emit(recyclePayload);
      this.onClose();
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  orgInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
}
